(() => {
  const initializeHeaderDirection = () => {
    const header = document.querySelector('store-header[hide-on-scroll]');

    if (!header || header.dataset.rmDirectionFix === 'true') {
      return;
    }

    header.dataset.rmDirectionFix = 'true';
    let lastScrollTop = Math.max(0, window.scrollY);
    let downwardDistance = 0;
    let frameRequested = false;

    const setHeaderVisible = (isVisible) => {
      header.getAnimations().forEach((animation) => animation.cancel());
      header.style.transition = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'none'
        : 'transform 200ms ease';
      header.style.transform = isVisible ? 'translateY(0)' : 'translateY(-100%)';
    };

    const update = () => {
      const currentScrollTop = Math.max(0, window.scrollY);
      const delta = currentScrollTop - lastScrollTop;

      if (delta < -1) {
        downwardDistance = 0;
        setHeaderVisible(true);
      } else if (delta > 0) {
        downwardDistance += delta;

        if (downwardDistance > 100 && currentScrollTop > 100) {
          setHeaderVisible(false);
        }
      }

      if (currentScrollTop <= 2) {
        downwardDistance = 0;
        setHeaderVisible(true);
      }

      lastScrollTop = currentScrollTop;
      frameRequested = false;
    };

    window.addEventListener('scroll', () => {
      if (!frameRequested) {
        frameRequested = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHeaderDirection, { once: true });
  } else {
    initializeHeaderDirection();
  }
})();
